module.exports = __webpack_public_path__ + "img/empty-student-report.0f72be8f.svg";